const useSelectOptionsByArray = (
  items: Array<string | number>,
  withEmptyValue: boolean = true
): Array<{ label: string; value: string | number }> => {
  const options = items.map((item) => {
    return { label: item.toString(), value: item };
  });

  return withEmptyValue ? [{ label: '', value: '' }, ...options] : options;
};

export default useSelectOptionsByArray;
